/* eslint-disable max-len */
import React, { useState } from 'react';
import { Button, Stack } from '@mui/material';
import AlertModal from 'components/shared/alert_modal';
import DataConfirmation from 'components/shared/data_confirmation';
import { PageTitle } from 'components/shared/page_title';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from 'routes/constants';

interface Step2Props {
  formik: any;
  onBack: () => void;
}

const Step2: React.FC<Step2Props> = ({ onBack, formik }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Extrai o ano da rota, ex: /service_management/cifa-2027 => 2027
  const match = /cifa-(\d{4})/.exec(location.pathname);
  const anoReferencia = match ? Number(match[1]) : 2026;

  const handleSave = async () => {
    formik.handleSubmit();
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    navigate(ROUTES[`INCLUDE_CIFA_${anoReferencia}` as keyof typeof ROUTES] as string);
  };

  return (
    <>
      <PageTitle
        title='Confirmação dos Dados'
        subtitle='Confira todas as informações que foram preenchidas, e altere-as caso necessário.'
      />

      <Stack marginX='4rem' spacing='2rem' maxWidth='1152px'>
        <DataConfirmation
          title='PMAF - Plano de Agricultura Familiar'
          data={[
            {
              label:
                'O Município elaborou o Plano Municipal de Agricultura Familiar - PMAF?',
              value: formik.values.termo_escolar_pmaf_elaborado ? 'Sim' : 'Não',
            },
            {
              label: 'O PMAF foi validado pela SEAF MT?',
              value: formik.values.termo_escolar_pmaf_validado_seaf_mt ? 'Sim' : 'Não',
            },
            {
              label: 'O município publicou ato normativo municipal instituindo a coordenação e equipe técnica responsável pela elaboração do PMAF, com participação do CMDRS?',
              value: formik.values.termo_escolar_ato_normativo_publicado ? 'Sim' : 'Não',
            },
          ]}
          document_uuid={formik.values.termo_escolar_ato_normativo_uuid}
          document_show={formik.values.termo_escolar_ato_normativo_publicado}

        />
        <DataConfirmation
          title='CMDRS - Conselho Municipal de Desenvolvimento Rural Sustentável'
          data={[
            {
              label:
                'O Município possui CMDRS constituído por Lei Municipal?',
              value: formik.values.termo_escolar_cmdrs_constituido ? 'Sim' : 'Não',
            },
          ]}
          document_uuid={formik.values.termo_escolar_atas_reunioes_uuid}
          document_show={formik.values.termo_escolar_cmdrs_constituido}

        />
        <DataConfirmation
          title='Formulário Prefeitura'
          data={[
            {
              label: 'O Município preencheu o formulário Prefeitura?',
              value: 'Não',
            },
          ]}
        />

        <Stack
          direction='row'
          spacing={2}
          justifyContent='center'
          alignItems='center'
          marginTop='2rem'
        >
          <Button variant='text' color='primary' onClick={onBack}>
            Voltar
          </Button>
          <Button variant='contained' color='primary' onClick={handleSave}>
            Confirmar e Salvar
          </Button>
        </Stack>

        <AlertModal
          open={isModalOpen}
          title='Etapa Concluída com Sucesso'
          message='O preenchimento dos dados dessa etapa foi concluído com sucesso. Continue realizando o preenchimento das próximas etapas para concluir o cadastro do Município no CIFA.'
          buttonLabel='Avançar'
          onClose={handleCloseModal}
        />
      </Stack>
    </>
  );
};

export default Step2;
